import { Form } from 'antd';
import Alarm from 'layouts/ShopLayout/Alarm';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import { HEIGHT_HEADER } from '../cashier.utils';
import CashierAddPrice from '../features/AddPrice';
import CashierCashDeposit from '../features/CashDeposit';
import CashierSellGift, { useCashierSellGift } from '../features/SellGift';
import OnHoldTickets from '../features/Tickets/OnHoldTickets';
import CashierVIP from '../features/VIP';

const HeaderActions = () => {
  const sellGift = useCashierSellGift();
  const onIssueGiftCard = () => sellGift.current?.open();
  return (
    <Container>
      <LeftBox>
        <div className='station-box'>
          <span>Station {storage.station_number.get()}</span>
        </div>
        <Alarm />
      </LeftBox>
      <RightBox>
        <CashierCashDeposit />

        <Form.List name={'items'}>
          {(_, { add }) => (<CashierAddPrice header onIssueGiftCard={onIssueGiftCard} add={add} />)}
        </Form.List>
        <Form.List name={'items'}>
          {(_, { add }) => (<CashierVIP add={add} />)}
        </Form.List>

        <Form.List name={'items'}>
          {(_, { add }) => (<CashierSellGift header ref={sellGift} add={add} />)}
        </Form.List>
        <OnHoldTickets />
      </RightBox>
    </Container>
  );
};

export default HeaderActions;

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  height: ${HEIGHT_HEADER}px;
  background: #FFF;
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25);
  background: #232f3e;
  align-self: stretch;
  .icon-left {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
  }
`;
const LeftBox = styled.div`
  flex: 1;
  display: flex;
  background: #232f3e;
  align-items: center;
  padding: 0 24px;
  gap: 24px;
  .station-box {
    display: flex;
    height: 42px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    background: #fff;
    white-space: nowrap;

    span {
      color: #1d2129;
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: uppercase;
    }
  }

  .today-label {
    display: flex;
    .digital {
      display: inline-flex;
      align-items: center;
    }
    .digital p {
      color: #fbe696;
      font-size: 55px;
    }
  }
  .clock .hour {
    line-height: unset;
  }
  .clock .hour .ampm,
  .clock .hour .digital :last-child {
    color: #fbe696;
    font-weight: 600;
  }
`;

const RightBox = styled.div`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: #FFF;
`;